<template>
    <div class="content">
        <p class="title">招聘公告详情</p>
        <div class="infoContent">
            <p class="tit">{{article.title}}</p>
            <p class="time">{{article.create_time_str}}</p>
            <div class="article ql-editor" v-html="article.content"></div>
        </div>
        <p class="fujian" v-if="article.file_url">附件：<el-button type="primary" size="mini" @click="showFujian">查看附件</el-button></p>
    </div>
</template>

<script>
import '@/assets/css/quill.bubble.css';
import '@/assets/css/quill.core.css';
import '@/assets/css/quill.snow.css';
export default {
    data() {
      return {
        id:'',
        article:[]
      }
    },
    created(){
        this.id=this.$route.query.id
        this.getInfo()
    },
    methods:{
        getInfo(){
            this.$axios
            .get(this.$api.getinfo,
                {id:this.id})
            .then((res) => {
                let data=res.result
                this.article=data
            });
        },
        showFujian () {
            window.open(this.article.file_url, '_blank')
            // let fileName = '';
            // let elink = document.createElement('a');
            // elink.download = fileName;
            // elink.style.display = 'none';
            // // elink.href = this.article.file_url;
            // elink.href = 'http://api.shunya.uulian.com.cn/files/files/20220428/16511317415993.jpg';
            // document.body.appendChild(elink);
            // elink.click();
            // URL.revokeObjectURL(elink.href);
            // document.body.removeChild(elink);
        }
    }
}
</script>

<style lang="less" scoped>
    .content{
        width: 1280px;
        min-height: calc(100vh - 230px);
        margin: 0 auto;
        padding: 30px 0;
        .title{
            line-height: 26px;
            font-size: 16px;
            color: #666;
            font-weight: 400;
            margin-bottom: 25px;
        }
        .infoContent{
            .tit{
                line-height: 62px;
                text-align: center;
                font-size: 38px;
                font-weight: bold;
                color: #333;
            }
            .time{
                width: 100%;
                line-height: 56px;
                text-align: center;
                font-size: 16px;
                color: #999;
                border-bottom: 1px solid #E4E7ED;
            }
            .article{
                line-height: 30px;
                padding: 15px 30px;
                font-size: 16px;
            }
        }
    }
    .fujian {
        margin: 20px 0;
    }
    

</style>